<template>
  <div v-title :data-title="$route.name">
    <!-- style=" border-style: solid; border-width: 5px; border-color: transparent;" -->
    <div
      v-if="offsetwidth > 850"
      style="
        width: 100%;
        overflow: hidden;
        position: relative;
        min-width: 1349px;
        margin-top: 65px;
        background-color: white !important;
      "
    >
      <div style="position: relative;">
        <img
           style="width:100%; height:100%; object-fit: cover"
          src="../assets/Battertimg/PC/Projecttop.jpg"
          alt=""
        />
        <div
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white !important;
            text-align: center;
            z-index: 10;
            width: 100%;
          "
        >
          <div
            style="
              font-size: 48px;
              font-family: Cotyledon-Regular-bold;
              line-height: 1;
              margin-bottom: 8px;
              width: 100%; /* 继承父级宽度 */
              text-align: center; /* 文本水平居中 */
            "
          >
            About Us
          </div>
        </div>
      </div>
    
      <!-- <div style="height:80px;background-color:white;width:100%"></div> -->
      <div class="flex flex_around">
        <div class="project-card">
          <div class="card_content">
            <!-- <div class="project-title text_left">About Section</div> -->

            <div class="flex flex_between">
              <div class="project-description">
                <p>
                  Battery Plant Victoria specialises in providing residential
                  solar and home battery solutions across Victoria. Our mission
                  is to help homeowners reduce electricity bills, increase
                  energy independence, and protect their homes with safe,
                  reliable, and efficient energy systems.
                </p>
                <p>
                  We supply and install high-quality, safety-focused systems
                  using approved products, ensuring every installation complies
                  with Australian safety and electrical standards, including
                  AS/NZS 5139 and AS/NZS 3000.
                </p>
                <p style="font-family: Cotyledon-Regular-bold">
                  Our team brings extensive industry experience:
                </p>
                <ul>
                  <li>
                    Our director has over 12 years of experience in the
                    renewable energy sector, including expertise in Victorian
                    government energy programs, rebates, and large-scale
                    residential installations.
                  </li>
                  <li>
                    All staff have a minimum of 3 years of experience in solar
                    and battery system design, installation, and maintenance,
                    ensuring expert service and high-quality workmanship.
                  </li>
                </ul>
                <p>
                  At Battery Plant Victoria, we combine technical expertise,
                  compliance knowledge, and hands-on experience to deliver
                  solutions that homeowners can trust for performance, safety,
                  and long-term reliability.
                </p>
              </div>
              <div class="project-img">
                <img src="../assets/Battertimg/PC/Project1.png" alt="" />
              </div>
            </div>
          </div>
          <!--  -->

          <!--  -->
          <div class="card_content" style="">
            <p class="project-title text_left">Home Battery Storage Systems</p>
            <div class="project-description">
              <p>
                Our battery systems allow you to store excess solar energy and
                use it when you need it most. We supply and install approved
                battery systems that are designed to offers you greater energy
                independence, reduce electricity bills, and protect your home
                during power outages.
              </p>
              <p style="font-family: Cotyledon-Regular-bold">
                Federal Government Home Battery Scheme - Rebate Program
              </p>
              <p>
                Starting 1 July 2025, the Australian Government's Cheaper Home
                Batteries Program offers eligible households a discount of
                around 30% on the upfront cost of small-scale home battery
                systems. Applicable for batteries with 5-100 kWh capacity,
                installed alongside rooftop solar.
              </p>
              <p>
                This helps reduce your initial cost, making clean, renewable
                energy storage more accessible than ever.
              </p>
              <p>
                With this discount, homeowners can enjoy the benefits of solar
                energy even when the sun isn't shining — at night or during
                outages — and cut electricity bills by storing and using their
                own solar power.
              </p>
              <div style="font-family: Cotyledon-Regular-bold">
                Eligibility Criteria:
              </div>
              <ul>
                <li>
                  The battery must be a
                  <span style="color: #0869b5">small-scale battery</span> with
                  usable capacity between
                  <span style="color: #0869b5"> 5 kWh and 100 kWh. </span>
                </li>
                <li>
                  The battery must be installed
                  <span style="color: #0869b5"
                    >with an existing solar PV system</span
                  >
                  or with a new solar PV system (i.e. cannot be a standalone
                  off-grid battery without solar PV).
                </li>
              </ul>
              <div
                style="font-family: Cotyledon-Regular-bold; margin-top: 1rem"
              >
                How Battery plant Victoria Helps:
              </div>
              <ul>
                <li>
                  The discounted installation is limited to a certain number of
                  households, so early application is highly recommended
                </li>
                <li>
                  We are an
                  <span style="color: #0869b5">NETCC-approved retailer</span>,
                  ensuring transparency and trust throughout the process
                </li>
                <li>
                  <span style="color: #0869b5">Accreditation:</span> Our
                  installers hold the required electrical licenses and, where
                  applicable, are accredited by the Clean Energy Council (CEC)
                  to install solar and battery systems.
                </li>

                <li>
                  <span style="color: #0869b5">Safety Compliance:</span>
                  Licensed installers follow strict safety protocols, Australian
                  electrical standards (AS/NZS 3000), and battery safety
                  standards (AS/NZS 5139), reducing risks such as fire, electric
                  shock, or system faults.
                </li>

                <li>
                  <span style="color: #0869b5">Professional Expertise:</span>
                  Qualified installers have experience handling different
                  battery types, solar panels, inverters, and grid connections.
                  They know how to design, mount, and wire systems correctly for
                  maximum efficiency and longevity.
                </li>

                <li>
                  <span style="color: #0869b5">Insurance Protection:</span>
                  Using licensed professionals ensures your installation is
                  covered by the installer's liability insurance, providing
                  peace of mind if any issues arise during or after
                  installation.
                </li>
                <li>
                  <span style="color: #0869b5">Quality Assurance:</span> Every
                  installation undergoes inspection and testing by qualified
                  personnel to ensure it meets design specifications, compliance
                  standards, and safety requirements.
                </li>
              </ul>
            </div>
            <div class="project-img3">
              <img src="../assets/Battertimg/PC/project3.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- 底部导航 -->
      <footer class="header-navbar">
        <!-- 第一行：LOGO和导航项 -->
        <div class="top-nav" style="height: 28px !important">
          <div class="logo-container">
            <div class="logo">
              <img
                style="height: 28px !important"
                src="../assets/Battertimg/PC/Batteryplantlogo.png"
                alt=""
              />
            </div>
          </div>

          <div class="nav-items">
            <div class="nav-item" @click="goto('HOME')">HOME</div>
            <div class="nav-item" @click="goto('PROJECT')">ABOUT US</div>
            <div class="nav-item" @click="goto('PRODUCTS')">PRODUCTS</div>
            <div class="nav-item" @click="goto('CASE')">GALLERY</div>
            <div class="nav-item" @click="goto('CONTACTUS')">CONTACT US</div>
            <div class="nav-item" @click="goto('CONTACTUS')">BOOK NOW</div>
          </div>
        </div>
        <div
          style="
            height: 1px;
            background-color: #cccccc;
            margin-top: 15px;
            margin-bottom: 18px;
          "
        ></div>
        <!-- 间距30px后的邮件信息 -->
        <div>
          <div class="email-content">(04) 5245 7579</div>
          <div class="email-content">info@batteryplant.com.au</div>
          <div class="email-content">203 Blackburn Rd Mount Waverley VIC 3149</div>
        </div>
      </footer>
    </div>
    <div v-else class="mobile-container">
      <div style="position: relative; display: inline-block; width: 100%">
        <img
          style="width: 100%"
          src="../assets/Battertimg/H5/projecttop.jpg"
          alt=""
        />
        <div
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #ffffff !important;
            font-size: 28px;
            font-family: Cotyledon-Regular-bold;
            text-align: center;
            width: 100%;
          "
        >
          About Us
        </div>
      </div>

      <div style="position: relative" class="mobile-content-section">
        <div>
          <div class="flex flex_around">
            <div class="project-card">
              <div class="card_content">
                <!-- <div class="project-title text_left">About Section</div> -->
                <div class="project-description">
                  <p>
                    Battery Plant Victoria specialises in providing residential
                    solar and home battery solutions across Victoria. Our
                    mission is to help homeowners reduce electricity bills,
                    increase energy independence, and protect their homes with
                    safe, reliable, and efficient energy systems.
                  </p>
                  <p>
                    We supply and install high-quality, safety-focused systems
                    using approved products, ensuring every installation
                    complies with Australian safety and electrical standards,
                    including AS/NZS 5139 and AS/NZS 3000.
                  </p>
                  <div style="font-family: Cotyledon-Regular-bold">
                    Our team brings extensive industry experience:
                  </div>
                  <ul>
                    <li>
                      Our director has over 12 years of experience in the
                      renewable energy sector, including expertise in Victorian
                      government energy programs, rebates, and large-scale
                      residential installations.
                    </li>
                    <li>
                      <p>
                        All staff have a minimum of 3 years of experience in
                        solar and battery system design, installation, and
                        maintenance, ensuring expert service and high-quality
                        workmanship.
                      </p>
                    </li>
                  </ul>
                  <p>
                    At Battery Plant Victoria, we combine technical expertise,
                    compliance knowledge, and hands-on experience to deliver
                    solutions that homeowners can trust for performance, safety,
                    and long-term reliability.
                  </p>
                </div>
                <img src="../assets/Battertimg/PC/Project1.png" alt="" />
              </div>
              <!--  -->

              <!--  -->
              <div class="card_content" style="">
                <div class="project-title text_left">
                  Home Battery Storage Systems
                </div>
                <div class="project-description">
                  <p>
                    Our battery systems allow you to store excess solar energy
                    and use it when you need it most. We supply and install
                    approved battery systems that are designed to offers you
                    greater energy independence, reduce electricity bills, and
                    protect your home during power outages.
                  </p>
                  <p style="font-family: Cotyledon-Regular-bold">
                    Federal Government Home Battery Scheme - Rebate Program
                  </p>
                  <p>
                    Starting 1 July 2025, the Australian Government's Cheaper
                    Home Batteries Program offers eligible households a discount
                    of around 30% on the upfront cost of small-scale home
                    battery systems. Applicable for batteries with 5-100 kWh
                    capacity, installed alongside rooftop solar.
                  </p>
                  <p>
                    This helps reduce your initial cost, making clean, renewable
                    energy storage more accessible than ever.
                  </p>
                  <p>
                    With this discount, homeowners can enjoy the benefits of
                    solar energy even when the sun isn't shining — at night or
                    during outages — and cut electricity bills by storing and
                    using their own solar power.
                  </p>
                  <div style="font-family: Cotyledon-Regular-bold">
                    Eligibility Criteria:
                  </div>
                  <ul>
                    <li>
                      The battery must be a
                      <span style="color: #0869b5">small-scale battery</span>
                      with usable capacity between
                      <span style="color: #0869b5"> 5 kWh and 100 kWh. </span>
                    </li>
                    <li>
                      The battery must be installed
                      <span style="color: #0869b5"
                        >with an existing solar PV system</span
                      >
                      or with a new solar PV system (i.e. cannot be a standalone
                      off-grid battery without solar PV).
                    </li>
                  </ul>
                  <div
                    style="
                      font-family: Cotyledon-Regular-bold;
                      margin-top: 1rem;
                    "
                  >
                    How Battery plant Victoria Helps:
                  </div>
                  <ul>
                    <li>
                      The discounted installation is limited to a certain number
                      of households, so early application is highly recommended
                    </li>
                    <li>
                      We are an
                      <span style="color: #0869b5">NETCC-approved retailer</span
                      >, ensuring transparency and trust throughout the process
                    </li>
                    <li>
                      <span style="color: #0869b5">Accreditation:</span> Our
                      installers hold the required electrical licenses and,
                      where applicable, are accredited by the Clean Energy
                      Council (CEC) to install solar and battery systems.
                    </li>

                    <li>
                      <span style="color: #0869b5">Safety Compliance:</span>
                      Licensed installers follow strict safety protocols,
                      Australian electrical standards (AS/NZS 3000), and battery
                      safety standards (AS/NZS 5139), reducing risks such as
                      fire, electric shock, or system faults.
                    </li>

                    <li>
                      <span style="color: #0869b5"
                        >Professional Expertise:</span
                      >
                      Qualified installers have experience handling different
                      battery types, solar panels, inverters, and grid
                      connections. They know how to design, mount, and wire
                      systems correctly for maximum efficiency and longevity.
                    </li>

                    <li>
                      <span style="color: #0869b5">Insurance Protection:</span>
                      Using licensed professionals ensures your installation is
                      covered by the installer's liability insurance, providing
                      peace of mind if any issues arise during or after
                      installation.
                    </li>
                    <li>
                      <span style="color: #0869b5">Quality Assurance:</span>
                      Every installation undergoes inspection and testing by
                      qualified personnel to ensure it meets design
                      specifications, compliance standards, and safety
                      requirements.
                    </li>
                  </ul>
                </div>
                <div>
                  <img src="../assets/Battertimg/PC/project3.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 在移动端部分（v-else内）修改底部导航栏 -->
      <footer class="mobile-footer-navbar">
        <!-- 垂直排列的容器 -->
        <div class="vertical-container">
          <!-- LOGO区域 -->
          <div class="logo-section">
            <div class="logo-container">
              <div class="logo">
                <img
                  style="height: 28px !important"
                  src="../assets/Battertimg/PC/Batteryplantlogo.png"
                  alt="Battery Plant Logo"
                />
              </div>
            </div>
          </div>

          <!-- 导航项区域（手动编写每个项） -->
          <div class="nav-section">
            <div
              class="nav-item"
              :class="{ active: activeNav === 0 }"
              @click="
                activateNav(0);
                goto('HOME');
              "
            >
              HOME
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 1 }"
              @click="
                activateNav(1);
                goto('PROJECT');
              "
            >
              ABOUT US
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 2 }"
              @click="
                activateNav(2);
                goto('PRODUCTS');
              "
            >
              PRODUCTS
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 3 }"
              @click="
                activateNav(3);
                goto('CASE');
              "
            >
              GALLERY
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 4 }"
              @click="
                activateNav(4);
                goto('CONTACTUS');
              "
            >
              CONTACT US
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 5 }"
              @click="
                activateNav(5);
                goto('CONTACTUS');
              "
            >
              BOOK NOW
            </div>
          </div>
          <div style="height: 1px; background-color: #cccccc"></div>
          <!-- 邮件信息区域 -->
          <div class="contact-section">
            <div class="email-contentmobile">(04) 5245 7579</div>
            <div class="email-contentmobile">info@batteryplant.com.au</div>
            <div class="email-contentmobile">203 Blackburn Rd Mount Waverley VIC 3149</div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    offsetwidth: {
      type: Number,
    },
  },
  data() {
    return {
      activeNav: null, // 跟踪当前激活的导航项
    };
  },
  mounted() {
    document.documentElement.scrollTop = 0;
  },

  methods: {
    handleImageClick(index) {
      // 确保预览组件已初始化
      this.$nextTick(() => {
        // 获取预览组件实例
        const viewer = document.querySelector(".el-image-viewer");

        if (viewer) {
          // 1. 自动触发放大操作
          this.autoZoom(viewer);

          // 2. 设置初始缩放比例
          setTimeout(() => {
            const img = viewer.querySelector(".el-image-viewer__img");
            if (img) {
              img.style.transform = "scale(1.5)"; // 初始放大1.5倍
            }
          }, 50);
        }
      });
    },
    autoZoom(viewer) {
      // 查找放大按钮并模拟点击
      const zoomInBtn = viewer.querySelector(".el-image-viewer__zoom-in");
      if (zoomInBtn) {
        // 点击两次达到2倍放大效果（可根据需要调整次数）
        zoomInBtn.click();
        setTimeout(() => zoomInBtn.click(), 30);
      }
    },
    // 激活导航项方法
    activateNav(index) {
      this.activeNav = index;
    },
    goto(name) {
      if (name == "HOME") {
        window.sessionStorage.setItem("activeIndexh5", "/index");
        this.$router.push("/index");
      } else if (name == "PROJECT") {
        window.sessionStorage.setItem("activeIndexh5", "/Project");
        document.documentElement.scrollTop = 0;
        // this.$router.push("/Project");
      } else if (name == "PRODUCTS") {
        window.sessionStorage.setItem("activeIndexh5", "/Productslist");
        this.$router.push("/Productslist");
      } else if (name == "CASE") {
        window.sessionStorage.setItem("activeIndexh5", "/Case");
        this.$router.push("/Case");
        // window.open('https://smartuser.com.au/customerdetails/')
        // this.$router.push("/ProjectGallery")
      } else if (name == "CONTACTUS") {
        window.sessionStorage.setItem("activeIndexh5", "/ContactUs");

        this.$router.push("/ContactUs");
      }
    },
    // goinfo() {
    //   // window.sessionStorage.setItem("activeIndex", "/CustomerDetails");
    //   this.$emit("fun", "/CustomerDetails");
    // },
  },
};
</script>
<style>
/* 全局样式 - 放在你的全局CSS文件中 */
/* 增加预览容器尺寸 */
/* .el-image-viewer__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
} */

/* 设置初始放大比例 */
/* .el-image-viewer__img {
  transform: scale(1.2) !important;
  transition: transform 0.3s ease;
} */

/* 隐藏操作按钮（可选） */
/* .el-image-viewer__btn {
  display: none !important;
} */
</style>
<style lang="scss" scoped>
ul {
  margin-left: 1rem;
}
ul li {
  list-style-type: disc;
  padding: 1rem 0 0 0;
}
@media (min-width: 1920px) {
  // 1.6
  .project-text-content {
    left: 27% !important;
    width: 21% !important;
  }
  .project-title {
    font-size: 38px !important;
  }

  .project-description {
    font-size: 17px !important;
  }
}
@media (min-width: 1600px) and (max-width: 1919px) {
  // 1.4
  .project-title {
    font-size: 33px !important;
  }

  .project-description {
    font-size: 19px !important;
  }
}

@media (min-width: 1440px) and (max-width: 1600px) {
  // 1.26
  .project-title {
    font-size: 30px !important;
  }

  .project-description {
    font-size: 17px !important;
  }
}

@media (min-width: 1301px) and (max-width: 1439px) {
  // 1.14
  .project-title {
    font-size: 27px !important;
  }

  .project-description {
    font-size: 16px !important;
  }
}
@media (min-width: 1200px) and (max-width: 1300px) {
  .project-title {
    font-size: 24px !important;
  }

  .project-description {
    font-size: 14px !important;
  }
}
</style>
<style scoped>
/* 移动端基础样式 - 以750px为基准 */
.mobile-container {
  width: 100%;
  border: 1px solid #f8f9fa;
  overflow: hidden;
  position: relative;
}

.mobile-top-banner {
  position: relative;
  display: inline-block;
  width: 100%;
}

.mobile-top-banner img {
  width: 100%;
}

.mobile-main-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff !important;
  font-size: 5.33vw; /* 750px下40px */
  font-family: Cotyledon-Regular-bold;
  text-align: center;
  width: 100%;
}

.mobile-content-section {
  position: relative;
}

.mobile-content-section img {
  width: 100%;
}

.mobile-text-container {
  position: absolute;
  width: 92%; /* 左右各留4%边距 */
  top: 26%;
  left: 4%;
  transform: translateY(-50%);
  text-align: left;
  z-index: 10;
  box-sizing: border-box;
}

.mobile-content-title {
  color: #000000;
  font-family: Cotyledon-Regular-bold;
  line-height: 1;
  margin-bottom: 8.53vw; /* 750px下64px */
  font-size: 5.33vw; /* 750px下40px */
}

.mobile-content-text {
  color: #000000;
  line-height: 1.5;
  /* font-family: Cotyledon-Regular-bold; */
  font-size: 4.8vw; /* 750px下36px */
}

/* 超小屏手机 (iPhone 5/SE) - 320px及以下 */
@media (max-width: 320px) {
  .mobile-main-title {
    font-size: 17.07px; /* 320/750*40 = 17.07px */
  }

  .mobile-content-title {
    font-size: 17.07px;
    margin-bottom: 27.31px; /* 320/750*64 = 27.31px */
  }

  .mobile-content-text {
    font-size: 15.36px; /* 320/750*36 = 15.36px */
  }
}

/* 小屏手机 - 321px-375px */
@media (min-width: 321px) and (max-width: 375px) {
  .mobile-main-title {
    font-size: 20px; /* 375/750*40 = 20px */
  }

  .mobile-content-title {
    font-size: 20px;
    margin-bottom: 32px; /* 375/750*64 = 32px */
  }

  .mobile-content-text {
    font-size: 15px; /* 375/750*36 = 18px */
  }
}

/* 中屏手机 (iPhone 6/7/8/X) - 376px-414px */
@media (min-width: 376px) and (max-width: 414px) {
  .mobile-main-title {
    font-size: 22.08px; /* 414/750*40 = 22.08px */
  }

  .mobile-content-title {
    font-size: 22.08px;
    margin-bottom: 35.33px; /* 414/750*64 = 35.33px */
  }

  .mobile-content-text {
    font-size: 16.87px; /* 414/750*36 = 19.87px */
  }
}

/* 大屏手机 - 415px-480px */
@media (min-width: 415px) and (max-width: 480px) {
  .mobile-main-title {
    font-size: 25.6px; /* 480/750*40 = 25.6px */
  }

  .mobile-content-title {
    font-size: 25.6px;
    margin-bottom: 40.96px; /* 480/750*64 = 40.96px */
  }

  .mobile-content-text {
    font-size: 18px; /* 480/750*36 = 23.04px */
  }
}

/* 小屏平板 - 481px-768px */
@media (min-width: 481px) and (max-width: 768px) {
  .mobile-main-title {
    font-size: 40px; /* 保持设计图大小 */
  }

  .mobile-content-title {
    font-size: 40px;
    margin-bottom: 64px; /* 保持设计图间距 */
  }

  .mobile-content-text {
    font-size: 30px; /* 保持设计图大小 */
  }

  .mobile-text-container {
    width: 80%; /* 平板增加内容区域宽度 */
    left: 10%;
  }
}

/* 针对横屏模式的优化 */
@media (max-height: 500px) and (orientation: landscape) {
  .mobile-text-container {
    top: 30%; /* 横屏时调整位置 */
  }

  .mobile-content-title {
    margin-bottom: 6vw; /* 横屏时减少间距 */
  }

  .mobile-content-text {
    font-size: 4vw; /* 横屏时减小字体 */
    line-height: 1.3;
  }
}
</style>
<style scoped>
.project-text-content {
  position: absolute;
  width: 30%;
  top: 22%;
  left: 14%;
  transform: translateY(-50%);
  text-align: left;
  z-index: 10;
}

.project-title {
  font-size: 24px;
  color: #000000;
  font-family: Cotyledon-Regular-bold;
  line-height: 1;
  margin-bottom: 45px;
}

.project-description {
  font-size: 14px;
  color: #000000;
  /* font-weight: 600; */
  line-height: 1;
  margin-bottom: 8px;
}

.project-card {
  background-color: #fff;
  text-align: left;
}
.project-card .card_content {
  padding: 20px 168px;
}
.project-img img {
  width: 605px;
  height: 403px;
}
.project-img {
  object-fit: fill;
  padding: 0 26px 26px 26px;
}
.project-img3 {
  text-align: center;
}
.project-img2 {
  float: left;
  clear: both;
}
.project-img2 img {
  width: 586px;
  height: 366px;
}
.pos_img2_text {
  top: 275px;
  width: 930px;
}
.project-img3 img {
  width: 560px;
  height: 283px;
}
.project-img,
.project-img2,
.project-img3 {
  object-fit: fill;
  padding: 0 26px 26px 26px;
}
/* 中等屏幕适配 */
@media (min-width: 1701px) and (max-width: 1920px) {
  .project-img img {
    width: 605px;
    height: 403px;
  }
  .project-img2 img {
    width: 586px;
    height: 366px;
  }
  .project-img3 img {
    width: 560px;
    height: 283px;
  }
  .project-card {
    background-color: #fff;
    text-align: left;
  }
  .project-card .card_content {
    padding: 20px 168px;
  }
  .project-text-content {
    left: 24% !important;
    width: 22% !important;
  }
  .project-title {
    font-size: 24px !important;
  }

  .project-description {
    font-size: 17px !important;
  }
}

/* 较小屏幕适配 */
@media (min-width: 600px) and (max-width: 1200px) {
  .project-card {
    background-color: #fff;
    text-align: left;
  }
  .project-card .card_content {
    padding: 20px 80px;
  }
  .project-img img {
    width: 378px;
    height: 252px;
  }

  .project-img2 img {
    width: 366px;
    height: 229px;
  }
  .project-img3 img {
    width: 350px;
    height: 177px;
  }
  .project-text-content {
    left: 13% !important;
    width: 30% !important;
    top: 20%;
  }

  .project-title {
    font-size: 24px !important;
    margin-bottom: 30px !important;
  }

  .project-description {
    font-size: 16px !important;
    margin-bottom: 6px;
  }
}
@media (min-width: 1200px) and (max-width: 1440px) {
  .project-card {
    background-color: #fff;
    text-align: left;
  }
  .project-card .card_content {
    padding: 20px 100px;
  }
  .project-img img {
    width: calc(378px * 1.3);
    height: calc(252px * 1.3);
  }
  .project-img2 img {
    width: calc(366px * 1.3);
    height: calc(229px * 1.3);
  }
  .project-img3 img {
    width: calc(350px * 1.3);
    height: calc(177px * 1.3);
  }
  .project-text-content {
    left: 13% !important;
    width: 30% !important;
    top: 20%;
  }

  .project-title {
    font-size: 24px !important;
    margin-bottom: 30px !important;
  }

  .project-description {
    font-size: 16px !important;
    margin-bottom: 6px;
  }
}
@media (min-width: 1450px) and (max-width: 1600px) {
  .project-card {
    background-color: #fff;
    text-align: left;
  }
  .project-card .card_content {
    padding: 20px 120px;
  }
  .project-text-content {
    left: 18% !important;
    width: 26% !important;
  }

  .project-title {
    font-size: 24px !important;
  }

  .project-description {
    font-size: 16px !important;
  }
}
/* 大屏幕适配 */
@media (min-width: 1600px) and (max-width: 1700px) {
  .project-card {
    background-color: #fff;
    text-align: left;
  }
  .project-card .card_content {
    padding: 20px 140px;
  }
  .project-text-content {
    left: 19%;
    width: 25%;
  }

  .project-title {
    font-size: 24px !important;
  }

  .project-description {
    font-size: 16px !important;
  }
}

/* 大屏幕适配 */
@media (width: 1200px) {
  .project-text-content {
    left: 20%;
    width: 26%;
  }

  .project-title {
    font-size: 24px !important;
  }

  .project-description {
    font-size: 14px !important;
  }
}
</style>
<style scoped>
@media (max-width: 750px) {
  .project-title {
    font-size: 18px !important;
    font-family: Cotyledon-Regular-bold;
    line-height: 1;
    margin-bottom: 20px;
  }
  .project-card {
    background-color: #fff;
    text-align: left;
  }
  .project-card .card_content {
    padding: 18px 15px;
  }
}
@media (min-width: 400px) and (max-width: 520px) {
  .project-card {
    background-color: #fff;
    text-align: left;
  }
  .project-card .card_content {
    padding: 20px 15px;
  }
  .innertitle {
    font-size: 19px !important;
  }
  .inner {
    font-size: 15px !important;
  }
}
@media (min-width: 520px) {
  .innertitle {
    font-size: 30px !important;
  }
  .inner {
    font-size: 28px !important;
  }
}
.image-row {
  /* 这里可以添加额外的行样式，但通常 <el-row> 会有默认的样式 */
  margin: 0; /* 去除行容器的外边距 */
}

.image-col {
  /* 由于我们使用了 :gutter="0"，这里通常不需要额外的间距样式 */
  padding: 0; /* 去除列容器的内边距（虽然 <el-col> 默认可能没有内边距） */
}

.image-container {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  gap: 0; /* 设置图片之间的间距为0 */
  margin: 0; /* 去除容器自身的外边距 */
  padding: 0; /* 去除容器自身的内边距 */
}

.image-container > el-image {
  flex: 0 0 calc(50% - 0px); /* 每列占据50%的宽度，0px是调整间距的，这里不需要额外间距 */
  box-sizing: border-box; /* 确保内边距和边框包含在宽度内 */
}

.vc_custom_1627269981297copy {
  /* margin-bottom: -40px !important; */
  padding-top: 50px !important;
  padding-bottom: 40px !important;
  background-color: #84b903 !important;
}
/* .vc_custom_1626061515335 {
  margin-bottom: -40px !important;
  padding-top: 50px !important;
  padding-bottom: 40px !important;
  background-color: #84b903 !important;
} */
/* .special-link {
  text-decoration: underline;
}
a:link {
  color: blue;
} */
/* 已访问的链接 */
/* a:visited {
  color: purple;
} */

/* 鼠标悬浮在链接上 */
/* a:hover {
  color: red;
} */

/* .mt_20 {
  margin-top: 20px;
}
.mt_10 {
  margin-top: 10px;
}
.text_bold {
  font-weight: 700;
}
.pcss {
  font-family: Poppins;
  font-weight: 300;
  font-style: normal;
  font-size: 15px;
}
.titlecss {
  font-family: Poppins;
  font-style: normal;
} */

/* 图片容器相对定位 */
.banner-text {
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-50%);
  color: white;
  text-align: left;
  z-index: 10;
}

.text-line-1 {
  font-size: clamp(24px, 3vw, 48px);
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 8px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.text-line-2 {
  font-size: clamp(18px, 2.2vw, 36px);
  font-weight: 600;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .banner-text {
    left: 8%;
  }
}

@media (max-width: 992px) {
  .banner-text {
    left: 6%;
  }
}

@media (max-width: 768px) {
  .banner-text {
    left: 5%;
  }

  .text-line-1 {
    font-size: clamp(20px, 4vw, 32px);
  }

  .text-line-2 {
    font-size: clamp(16px, 3vw, 24px);
  }
}
</style>
<style scoped>
.header-navbar {
  padding: 20px 40px;
  background-color: white;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
}
.top-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo-container {
  flex-shrink: 0;
}
.logo {
  display: flex;
  align-items: center;
  gap: 8px;
}
.logo-icon {
  font-size: 24px;
}
.logo-text {
  font-size: 18px;
  font-weight: 600;
}
.nav-items {
  display: flex;
  gap: 30px;
}
.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}
/* 悬停和激活状态统一效果 */
.nav-item:hover,
.nav-item.active {
  color: #0c80da !important;
  /* border-bottom-color: #0c80da !important; */
}
/* 下划线动画效果 */
/* .nav-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 1px;
  background-color: #1890ff;
  transition: width 0.3s;
} */
.nav-item:hover::after,
.nav-item.active::after {
  width: 100%; /* 悬停和激活时下划线宽度一致 */
}
.email-info {
  margin-top: 30px;
}
.email-content {
  font-size: 12px;
  color: #666;
  text-align: right;
  line-height: 1.6;
}
@media (max-width: 768px) {
  .top-nav {
    flex-direction: column;
    gap: 20px;
  }

  .nav-items {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }

  .email-content {
    text-align: center;
  }
}
</style>
<style scoped>
/* 移动端底部导航栏样式 */
.mobile-footer-navbar {
  background-color: white;
  padding: 20px;
  /* box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); */
}
.vertical-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.logo-section,
.nav-section,
.contact-section {
  text-align: left; /* 确保左对齐 */
}
.logo-container {
  margin-bottom: 10px;
}
.nav-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}
/* 悬停和激活状态统一效果 */
.nav-item:hover,
.nav-item.active {
  color: #0c80da !important;
  /* border-bottom-color: #0c80da !important; */
}
.contact-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.email-contentmobile {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
}
/* 响应式调整 */
@media (max-width: 480px) {
  .vertical-container {
    gap: 15px;
  }

  .nav-section {
    gap: 2px;
  }

  .nav-item {
    font-size: 14px;
    font-weight: bold;
  }

  .email-contentmobile {
    font-size: 12px;
  }
}
</style>
